<script lang="ts">
  import {Button, StepFourButton} from '@components';
  import {createEventDispatcher, SvelteComponent} from 'svelte';
  import loadingStore from '@/pages/preview/loading-store';
  import PreviewBtn from '../preview-btn/PreviewBtn.svelte';
  import ProjectTopNav from '../projects-view/ProjectTopNav.svelte';
  const dispatch = createEventDispatcher();

  export let step = 0;
  export let label = '';
  export let disabled = false;
  export let hasPrevious = false;
  export let hasDownload = false;
  export let hasPreview = false;

  let loadingNext: boolean = false;
  let loadingPrev: boolean = false;

  export const cancelNext = () => {
    loadingNext = false;
  };

  const onNext = () => {
    if (disabled) {
      dispatch('disabled');
      return;
    }

    loadingNext = true;
    dispatch('next');
  };

  const onPrev = () => {
    loadingPrev = true;
    dispatch('prev');
  };

  const onDownload = () => dispatch('download', {qualityPreset: 'default'});
  const options = [
    {
      title: 'Highest Quality',
      description: 'Default method & Most Used',
      isRecommended: true,
      action: () => {
        dispatch('download', {qualityPreset: 'default'});
      }
    },
    {
      title: 'Smaller Size',
      description: 'Required when posting with social media schedulers',
      isRecommended: false,
      action: () => {
        dispatch('download', {qualityPreset: 'medium'});
      }
    },
    {
      title: 'Export to Sermon Send',
      description: 'Add to Sermon Send library',
      isRecommended: false,
      action: () => {
        dispatch('download', {qualityPreset: 'sermonSend'});
      }
    }
  ];
</script>

<div class="z-50 flex w-full items-center gap-4 bg-white !px-6 !py-4 shadow-md">
  {#if hasPrevious}
    <Button text="Previous" on:click={onPrev} variant="primary" loading={loadingPrev} />
  {/if}
  <div class="flex flex-grow items-center gap-2 uppercase">
    <div id="step-{step}-tooltip"><span class="font-bold">STEP {step}: {label}</span></div>
    <!-- {#if infoModal}
        <InfoModal component={infoModal} />
        {/if} -->
  </div>
  {#if hasDownload}
    <ProjectTopNav />
    {#if hasPreview}
      <PreviewBtn />
    {/if}
    <StepFourButton disabled={$loadingStore} on:click={onDownload} {options} />
  {:else}
    <div id="topnav_next_{step}">
      <Button text="Next" on:click={onNext} variant="primary" loading={loadingNext} />
    </div>
  {/if}
</div>
